import { useEffect, useMemo, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";

import { getUserRole } from "../../utils/authUtils";
import { otherPortalCards } from "./constants";
import { bannerService } from "../Banner Management/bannerAPI";
import { BannerData } from "../Banner Management/banner.types";
import Banner from "../../components/Banner/Banner";
import { RootState } from '../../store/store';
import User from "../../types/user";

import PortalGraphicLogo from "../../assets/images/portal-graphic-logo.svg";
import "./Home.css";

const Home = () => {
  const [bannerListData, setBannerListData] = useState<BannerData[]>([]);
  const [bannerVisited, setBannerVisited] = useState(
    localStorage.getItem("bannerVisited") === "true"
  );
  const user = useSelector((state: RootState) => state.users.loginUser);
  const { isAdmin, isAuditor, isCustomer, isLogoPortalUser, isLogoPortalSubUser, isOpsUser} = getUserRole(user as User);

  /**
   *  Fetch banner
   */
  const fetchBanner = async () => {
    try {
      let result = await bannerService.fetchBanners();
      if (result && result[0]?.id) {
        setBannerListData(prev => [...prev, ...result]);
      }
    } catch (error: any) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchBanner();
  }, []);

  /**
   * On banner close
   */
  const onCloseBanner = () => {
    localStorage.setItem("bannerVisited", "true");
    setBannerVisited(true);
  }


  /**
   * Check banner should display or not
   */
  const shouldBannerDisplay = useMemo(() => {
    if (bannerVisited) return false;
    if (!bannerListData.length) return false;

    const banner = bannerListData[0];

    if (!banner.visibility) return false;
    if (!banner.startDate || !banner.endDate) return false;

    const now = new Date();
    
    const today = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    ).getTime();

     const start = new Date(banner.startDate).setHours(0, 0, 0, 0);
     const end = new Date(banner.endDate).setHours(23, 59, 59, 999);

     return today >= start && today < end;
  }, [bannerListData, bannerVisited]);


  /**  Temporarily commented for :- YA502-516  */
  /*const portalCards = [
    ...(isAdmin ? adminPortalCards : []),
    ...(isAuditor ? auditorPortalCards : []),
    ...(isCustomer ? customerPortalCards : []),
    ...otherPortalCards,
  ];*/

  let descriptionText = "";   // If text is empty then we are showing no role assigned message

  if (isAdmin) {
    descriptionText = "This portal is designed to streamline your experience and make navigating your tasks simple and efficient. Whether you're using the Customer Portal, Logo Portal, or exploring our wide range of additional resources, everything you need is just a click away.";
  } else if (isAuditor) {
    descriptionText = "This portal is designed to streamline your experience and make navigating your tasks simple and efficient. Whether you’re using the Auditor Portal, or exploring our wide range of additional resources, everything you need is just a click away.";
  } else if (isCustomer) {
    descriptionText = "This portal is designed to streamline your experience and make navigating your tasks simple and efficient. Whether you’re using the CAR Portal, Logo Portal, or exploring our wide range of additional resources, everything you need is just a click away.";
  } else if (isLogoPortalUser || isLogoPortalSubUser || isOpsUser) {
    descriptionText = "This portal is designed to streamline your experience and make navigating your tasks simple and efficient. Whether you're using the Customer Portal, Logo Portal, or exploring our wide range of additional resources, everything you need is just a click away.";
  }

  const portalCards = [
    ...otherPortalCards,
  ];

  return (
    <>
      {
        shouldBannerDisplay &&
        <Banner
          messages={[bannerListData[0].message]}
          autoHideTime={0}
          onClose={() => onCloseBanner()}
        />
      }
      <main className="container-fluid">
        <div className="main main-app p-3 p-lg-4">
          <Row className="align-items-center text-center text-md-start rootApp-header">
            <Col md={6}>
              <h2 className="rootApp-title">{`Welcome, ${user?.firstName}`}</h2>
              <p className="rootApp-subtitle">Always stay updated in your SCS Project Portal</p>
            </Col>
            <Col md={6} className="text-center position-relative">
              <img
                src={PortalGraphicLogo}
                className="img-fluid rootApp-logo"
                alt="Portal Graphic"
              />
            </Col>
          </Row>
          <div className="mt-4 bg-white p-5 rootApp-subcontainer">
            {descriptionText !== "" ? (
              <div className="mt-2 bg-white p-2 rootApp-subcontainer">
                <h2 className="mb-4 rootApp-subcontainer-header">Getting started</h2>
                <p className="rootApp-subcontainer-des">{descriptionText}
                </p>

                <div className="my-4 iframe-container">
                  <Row>
                    {portalCards.map((item, index) => (
                      <Col key={index} xs={12} sm={12} md={6} xxl={4} className="mb-4">
                        <div className="ratio ratio-1x1">
                          <iframe
                            src={item.srcURL}
                            title={`Iframe ${index + 1}`}
                            allowFullScreen
                            style={{
                              border: 0,
                              width: "100%",
                              height: "100%",
                            }}
                          ></iframe>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
              </div>
            ) : (
              <div className="bg-white p-5 text-center" style={{ minHeight: "250px" }}>
                <p className="rootApp-subcontainer-des">You don’t have the correct role assigned to your account. Please contact your account manager.</p>
              </div>
            )}
            <hr></hr>
            <Row className="rootApp-footer">
              {/* <Col md={3}>User Settings</Col> */}
              <Col md={3}>
                <a
                  className="rootApp-footer-link"
                  href="https://scsglobalservices.atlassian.net/servicedesk/customer/portal/13"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Contact Support
                </a>
              </Col>
            </Row>
          </div>
        </div>
      </main>
    </>
  );
};

export default Home;
